module.exports = __webpack_public_path__ + "img/collection-weddingRingsGayLesbianCouples.0d0d37b.jpg";